export default __webpack_public_path__ + "static/media/pranjal.e8af2e6d.png";